import React from 'react';
import {StickyHeader} from '.';
import {List} from '@mui/material';
import NavMenuItem from './NavMenuItem';

interface ExtrasMenuList {
  transparent: boolean;
  menus: StickyHeader['extras']['items'];
  onClick: () => void;
}

const ExtrasMenuList: React.FC<ExtrasMenuList> = React.memo((props) => {
  return (
    <List
      sx={{
        // !important is added because the li style in the reset file affects the padding
        paddingTop: '80px !important',
      }}>
      {props.menus.map((menu) => (
        <NavMenuItem
          transparent={props.transparent}
          onClick={props.onClick}
          label={menu.label}
          key={menu.label}
          link={menu.link}
          query={menu.query}
        />
      ))}
    </List>
  );
});

export default ExtrasMenuList;
export type {ExtrasMenuList};
